// extracted by mini-css-extract-plugin
export default {"contentSection":"AboutPage_contentSection__yAk8p","mainTitle":"AboutPage_mainTitle__Fff5R","finalNote":"AboutPage_finalNote__wXIqw"};